import { DatePipe, DecimalPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { StandardRequestService } from '../../standard-requests/standard-request.service';
import { StandardRequestsFilterService } from '../../standard-requests/standard-requests-filter.service';
import { StandardRequestDetailService } from '../standard-request-detail.service';

@Component({
    selector: 'app-standard-request-detail-header',
    templateUrl: './request-detail-header.component.html',
    standalone: true,
    imports: [
        NgIf,
        ButtonDirective,
        TooltipModule,
        DatePipe,
        TranslateModule,
        DecimalPipe
    ]
})
export class StandardRequestDetailHeaderComponent {

    get translatedStatus(): string {
        const status = `STATUS.${this.standardRequestDetailService.request.personQuery.status}`;
        return this.translateService.instant(status);
    }

    get feasibilityResult(): number {
        return this.standardRequestDetailService.feasibilityData.creditAmount;
    }

    constructor(
        public readonly standardRequestDetailService: StandardRequestDetailService,
        public readonly standardRequestsFilterService: StandardRequestsFilterService,
        public readonly standardRequestService: StandardRequestService,
        private readonly router: Router,
        private readonly translateService: TranslateService
    ) { }

    navigateToRequests(): void {
        this.router.navigate(['/standard']).catch(error => { console.error(error); });
    }
}
